import { css } from 'styled-components';
import { map } from '../../breakpoint';
import { getSpacingFromTheme } from '../../spacing/core';
export function getSpacingValues(values) {
  return function (_ref) {
    let {
      theme
    } = _ref;
    return getSpacingFromTheme(values, theme);
  };
}
export const gap = () => css`
  ${_ref2 => {
  let {
    gap
  } = _ref2;
  return map(gap, val => val != undefined && css`
          gap: ${getSpacingValues(val)};
        `);
}};
`;
export const columnGap = () => css`
  ${_ref3 => {
  let {
    columnGap
  } = _ref3;
  return map(columnGap, val => val != undefined && css`
          column-gap: ${getSpacingValues(val)};
        `);
}};
`;
export const rowGap = () => css`
  ${_ref4 => {
  let {
    rowGap
  } = _ref4;
  return map(rowGap, val => val != undefined && css`
          row-gap: ${getSpacingValues(val)};
        `);
}};
`;